import React from "react";
import aboutUsImage from "assets/images/about-us.png";
import { useTranslation } from "react-i18next";

function AboutUsPageContent() {

	const { t } = useTranslation();

	return (
		<div className="mt-10">
			<div className="container flex gap-10 items-center">
				<img src={ aboutUsImage } alt="ABOUT_US_IMAGE" className="h-[500px] object-cover hidden lg:block"/>
				<div className="flex flex-col gap-4 text-black">
					<div className="text-3xl font-medium leading-[48px]">
						{ t(`aboutUsPage.content.title`) }
					</div>
					<div className="text-base font-normal">
						<p className="mb-4">
							{ t(`aboutUsPage.content.text.part1`, "") }
						</p>
						<p className="mb-4">
							{ t(`aboutUsPage.content.text.part2`, "") }
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default AboutUsPageContent;